// RevisedTable 组件，来自 CustomLoanSkipDialog
interface RevisedTableProps {
  revisedData: any;
  curPV: any;
  record: any;
}

import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as React from "react";
import { useRefresh } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import PaperComponent from "../../unit/PaperComponent";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import CustomControlEditTextField from "../../unit/forms/CustomControlEditTextField";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";
import CustomEditControlSelect from "../../unit/forms/CustomEditControlSelect";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import NoResults from "../../unit/NoResults";
import { Close, Preview } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/GetApp";
import CustomDownloadFile from "../../unit/CustomDownloadFile";
const CustomPreviewData = ({ ...props }) => {
  const dataArray = props.data;

  let prev: null = null;
  // console.log("dataArray===>", dataArray);
  const getActualInterestAmountPaid = (item: any, prev: any) => {
    let dActualAmountPaid = parseFloat(item.dActualAmountPaid);
    let interestAmount_total = 0;
    let latefee_total = 0;
    if (prev && prev.dInterestPastDueSum) {
      interestAmount_total =
        parseFloat(item.interestAmount) + parseFloat(prev.dInterestPastDueSum);
    } else {
      interestAmount_total = parseFloat(item.interestAmount);
    }
    if (prev && prev.dLateFeePastDueSum) {
      latefee_total =
        parseFloat(item.dLateFees) + parseFloat(prev.dLateFeePastDueSum);
    } else {
      latefee_total = parseFloat(item.dLateFees);
    }
    if (interestAmount_total > 0) {
      if (dActualAmountPaid >= interestAmount_total) {
        return dActualAmountPaid > 0
          ? formatCurrency(interestAmount_total)
          : "";
      } else {
        return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
      }
    } else {
      return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
    }
  };

  let show_invoice_edit = false;
  let latefeeSum = 0;
  let eq_cal = 0;

  return (
    <TableContainer
      component={CustomPaper}
      sx={{
        mt: 2,
        width: `calc(100%)`,
        height: `300px`,
        overflow: "auto",
      }}
    >
      <CustomTable
        stickyHeader
        sx={{
          "& .MuiTableRow-head": {
            border: "1px solid #d5d5d5",
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
            color: "red",
          },

          "& .MuiTableCell-head": {
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
          },
        }}
      >
        <TableHead>
          <TableRow>
            {/* <TableCell>Payment Number</TableCell> */}
            <TableCell sx={{ minWidth: "150px" }}>Payment Due Date</TableCell>
            <TableCell align="right">Expected Payment Amount</TableCell>
            {/* <TableCell>Invoice Amount</TableCell> */}
            {/* <TableCell sx={{ minWidth: "120px" }}>Actual Payment Date</TableCell> */}
            {/* <TableCell>Actual Payment Amount</TableCell> */}
            {/* <TableCell>Interest Paid</TableCell>
          <TableCell>Principal Paid</TableCell>
          <TableCell>Cumulative Principal Balance</TableCell>
          <TableCell>Remaining Principal Balance</TableCell> */}
            {/* <TableCell>Days Past Due</TableCell> */}
            {/* <TableCell>Amount Past Due</TableCell> */}
            {/* <TableCell>Late Fees</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataArray == undefined ||
          dataArray.length == 0 ||
          dataArray == null ? (
            <TableRow>
              <TableCell colSpan={13} className="no-results">
                <NoResults />
              </TableCell>
            </TableRow>
          ) : (
            <>
              {dataArray.map((item: any, index: any) => {
                if (item.dActualAmountPaid > 0 && item.principalReduction > 0) {
                  eq_cal += item.principalReduction;
                }
                if (index > 0) {
                  prev = dataArray[index - 1];
                }
                if (item.sStatus != "pending") {
                  // continue;
                  return null;
                }

                return (
                  <TableRow key={index}>
                    {/* <TableCell>{index + 1}</TableCell> */}
                    <TableCell className="dateText">
                      {formatDate(item.dPaymentDate)}
                    </TableCell>
                    <TableCell className="amountText">
                      {formatCurrency(item.paymentAmount)}
                    </TableCell>
                    {/* <TableCell className="amountText">
                    {item.dPaymentDate < new Date()
                      ? formatCurrency(item.dOriginalInvoiceAmount)
                      : ""}
                  </TableCell> */}
                    {/* <TableCell className="dateText">
                    {item.dLastActualPaidDate != "" &&
                    item.dLastActualPaidDate != "0000-00-00 00:00:00"
                      ? formatDate(item.dLastActualPaidDate)
                      : ""}
                  </TableCell> */}
                    {/* <TableCell className="amountText">
                    {item.dActualAmountPaid > 0
                      ? formatCurrency(item.dActualAmountPaid)
                      : ""}
                  </TableCell> */}
                    {/* <TableCell className="amountText">
                    {getActualInterestAmountPaid(item, prev)}
                  </TableCell>
                  <TableCell className="amountText">
                    {item.dActualAmountPaid > 0 && item.principalReduction > 0
                      ? formatCurrency(item.principalReduction)
                      : ""}
                  </TableCell>
                  <TableCell className="amountText">
                    {item.dActualAmountPaid > 0 ||
                    item.sStatus == "expired" ||
                    item.sStatus == "failed"
                      ? formatCurrency(eq_cal)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 && item.dActualLoanBalance > 0
                      ? formatCurrency(item.dActualLoanBalance)
                      : ""}
                  </TableCell> */}
                    {/* <TableCell className="numericText">
                    {item.iDaysPastDue}
                  </TableCell> */}
                    {/* <TableCell className="amountText">
                    {formatCurrency(item.dAmountPastDue)}
                  </TableCell> */}
                    {/* <TableCell className="amountText">
                    {formatCurrency(item.dLateFees)}
                  </TableCell> */}
                  </TableRow>
                );
              })}
            </>
          )}
        </TableBody>
      </CustomTable>
    </TableContainer>
  );
};

const extractFileName = (contentDisposition: string | null) => {
  const formatLoanModifyFileName = (fileName: string) => {
    if (!fileName) {
      return "Loan Modification Agreement.pdf";
    }

    if (/Loan Modification Agreement\.pdf$/i.test(fileName)) {
      return fileName;
    }

    const cleanedFileName = fileName.trim();
    const pdfMatch = cleanedFileName.match(/^(.*)\.pdf$/i);

    if (!pdfMatch?.[1]) {
      return "Loan Modification Agreement.pdf";
    }

    const baseName = pdfMatch[1].trim();
    return `${baseName}_Loan Modification Agreement.pdf`;
  };

  if (!contentDisposition) {
    return "Loan Modification Agreement.pdf";
  }

  const utfFileNameMatch = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i
  );
  if (utfFileNameMatch?.[1]) {
    return formatLoanModifyFileName(decodeURIComponent(utfFileNameMatch[1]));
  }

  const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (fileNameMatch?.[1]) {
    return formatLoanModifyFileName(fileNameMatch[1]);
  }

  return "Loan Modification Agreement.pdf";
};

const getErrorMessage = async (response: Response) => {
  const responseText = await response.text();

  try {
    const responseJson = JSON.parse(responseText);
    return responseJson?.message || "Download failed";
  } catch (_error) {
    return responseText || "Download failed";
  }
};

const normalizeNumericInput = (value: unknown) => {
  if (value == null) {
    return "";
  }

  return value.toString().replace(/,/g, "").trim();
};

const parseRequiredNumber = (value: unknown) => {
  const normalizedValue = normalizeNumericInput(value);

  if (normalizedValue === "") {
    return 0;
  }

  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const parseOptionalNumber = (value: unknown) => {
  const normalizedValue = normalizeNumericInput(value);

  if (normalizedValue === "") {
    return "";
  }

  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : "";
};

const GeneratePdfDialog = ({ ...props }) => {
  const { appId, onClose, open, onDeleteBackToModify } = props;
  const { successNotify, errorNotify } = useNotify();
  const [pdfUrl] = React.useState(props?.pdflink);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [actionLoading, setActionLoading] = React.useState<
    "send" | "delete" | null
  >(null);
  const [downloadProgress, setDownloadProgress] = React.useState<number | null>(
    null
  );
  const triggerBrowserDownload = (blob: Blob, downloadName: string) => {
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.setAttribute("download", downloadName);
    document.body.appendChild(link);
    link.click();

    window.setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    }, 100);
  };
  const downloadFileFun = async (appId: any, pdfUrl: any) => {
    const reqUrl = "/downloadOtherPdf/loan_modify/" + pdfUrl;
    try {
      setIsDownloading(true);
      setDownloadProgress(0);

      const response = await sendRequest(reqUrl, null, "get", {
        rawResponse: true,
      });

      if (!(response instanceof Response)) {
        throw new Error("Download response is invalid.");
      }

      if (!response.ok) {
        throw new Error(await getErrorMessage(response));
      }

      const contentType = response.headers.get("content-type") || "";
      if (
        contentType.includes("application/json") ||
        contentType.includes("text/html")
      ) {
        throw new Error(await getErrorMessage(response));
      }

      const nextFileName = extractFileName(
        response.headers.get("content-disposition")
      );

      const contentLength = Number(response.headers.get("content-length") || 0);
      const reader = response.body?.getReader();

      if (!reader) {
        const blob = await response.blob();

        if (!blob.size) {
          throw new Error("File not found.");
        }

        triggerBrowserDownload(blob, nextFileName);
        setDownloadProgress(100);

        return;
      }

      const chunks: ArrayBuffer[] = [];
      let receivedLength = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }

        if (value) {
          const normalizedChunk = new Uint8Array(value.byteLength);
          normalizedChunk.set(value);
          chunks.push(normalizedChunk.buffer);
          receivedLength += normalizedChunk.length;

          if (contentLength > 0) {
            setDownloadProgress(
              Math.min(100, Math.round((receivedLength / contentLength) * 100))
            );
          } else {
            setDownloadProgress(null);
          }
        }
      }

      const blob = new Blob(chunks, {
        type: contentType || "application/octet-stream",
      });

      if (!blob.size) {
        throw new Error("File not found.");
      }

      triggerBrowserDownload(blob, nextFileName);
      setDownloadProgress(100);
    } catch (error: any) {
      console.error("Download failed", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleLoanModifyFileAction = async (action: "send" | "delete") => {
    if (!appId || !pdfUrl) {
      errorNotify("PDF information is missing.");
      return;
    }

    const encodedPdfLink = encodeURIComponent(pdfUrl);
    const reqUrl =
      action === "send"
        ? `confirm/trigger/loanmodify/${encodedPdfLink}`
        : `confirm/remove/loanmodify/${encodedPdfLink}`;

    try {
      setActionLoading(action);
      // const response: any = await sendRequest(reqUrl, null, "post");
      const response: any = await sendRequest(
        reqUrl,
        {
          id: appId,
          data: {},
        },
        "post"
      );
      // if (!response) {
      //   throw new Error("Request failed.");
      // }
      console.log("response from action========>.", response?.code);
      if (
        response?.code === "200" ||
        response?.code === 200 ||
        response?.status === "200" ||
        response?.status === 200
      ) {
        successNotify(
          action === "send"
            ? "Loan modification PDF sent to borrower"
            : "Loan modification PDF deleted"
        );
        if (action === "delete") {
          if (onDeleteBackToModify) {
            onDeleteBackToModify();
          } else {
            onClose();
          }
        } else {
          onClose();
        }
      } else {
        throw new Error(response?.message || "Request failed.");
      }
    } catch (error: any) {
      errorNotify(error?.message || "Request failed.");
    } finally {
      setActionLoading(null);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      PaperProps={{
        component: "form",
      }}
    >
      <DialogTitle
        sx={{
          position: "relative",
          borderBottom: "1px solid #e5e5e5",
          mb: 1,
        }}
      >
        <CustomDialogTitle title={`Loan Modification Agreement`} />
        {/* add Close X */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {pdfUrl ? (
          <>
            <List
              sx={{
                width: "100%",
                maxWidth: "100%",
                bgcolor: "background.paper",
              }}
            >
              {/* <ListItem key={appId}>
                <Link
                  sx={{
                    fontSize: "16px",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    await downloadFileFun(appId, pdfUrl);
                  }}
                >
                  Loan Modification Agreement
                  {!isDownloading && (
                    <DownloadIcon
                      sx={{ fontSize: "20px", verticalAlign: "Bottom" }}
                    />
                  )}
                  {isDownloading && (
                    <>
                      <CircularProgress
                        size={16}
                        color="inherit"
                        variant={
                          typeof downloadProgress === "number"
                            ? "determinate"
                            : "indeterminate"
                        }
                        value={downloadProgress ?? undefined}
                        sx={{
                          marginLeft: "10px",
                          verticalAlign: "Bottom",
                        }}
                      />
                      <Typography
                        component="span"
                        sx={{
                          ml: 1,
                          fontSize: "12px",
                          verticalAlign: "middle",
                        }}
                      >
                        {typeof downloadProgress === "number"
                          ? `${downloadProgress}%`
                          : "Downloading..."}
                      </Typography>
                    </>
                  )}
                </Link>
              </ListItem> */}
              <ListItem key="text-body" sx={{ alignItems: "flex-start" }}>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.primary"
                    sx={{ fontWeight: 600, mb: 0.5 }}
                  >
                    The modified loan terms have been saved. The new loan
                    payment schedule has replaced the existing one. The Loan
                    Modification Agreement including the new schedule has been
                    generated.
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </>
        ) : (
          <Typography variant="body1" sx={{ textAlign: "center" }}>
            Generating PDF...
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", mb: 0 }}>
        <CustomButtonSave
          label={isDownloading ? "loading" : "Download File"}
          onClick={() => downloadFileFun(appId, pdfUrl)}
          disabled={!pdfUrl || actionLoading !== null || isDownloading}
          sx={{
            width: "auto",
            bgcolor: "success.main",
            color: "#fff",
            "&:hover": {
              bgcolor: "success.dark",
            },
          }}
        />
        {/* <CustomButtonCancel onClick={onClose} label="Close" /> */}
        {/* <CustomButtonSave
          label={actionLoading === "delete" ? "loading" : "Delete File"}
          onClick={() => handleLoanModifyFileAction("delete")}
          disabled={!pdfUrl || actionLoading !== null || isDownloading}
          sx={{
            width: "140px",
            bgcolor: "error.main",
            color: "#fff",
            "&:hover": {
              bgcolor: "error.dark",
            },
          }}
        /> */}
        <CustomButtonSave
          label={actionLoading === "send" ? "loading" : "Request E-Signature"}
          onClick={() => handleLoanModifyFileAction("send")}
          disabled={!pdfUrl || actionLoading !== null || isDownloading}
          sx={{ width: "auto" }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default function CustomLoanModifyDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const setting = record?.setting;
  const havePendingTransfers = record?.loan?.havePendingTransfers
    ? true
    : false;
  const max_latefee = setting?.max_latefee;
  const max_grace_period = setting?.max_graceperiod;
  const adjust_latefee = setting?.latefee_adjust;
  const adjust_grace_period = setting?.grace_period_adjust;
  const min_amount = setting?.minAmount;
  const max_amount = setting?.maxAmount;
  const [showGeneratePdfDialog, setShowGeneratePdfDialog] =
    React.useState(false);
  const [loanModificationPdf, setLoanModificationPdf] = React.useState("");
  const [previewData, setPreviewData] = React.useState<any[]>([]);
  const [revisedData, setRevisedData] = React.useState<any[]>([]);
  const lastDate = record?.lastDate;
  const [minFixedAmount, setMinFixedAmount] = React.useState(0);
  const accruedInterestAmount = record?.accruedInterestAmount?.toString();
  const oldAmount = record?.unpaid_principal?.toString();
  const [balance, setBalance] = React.useState(oldAmount);
  const [
    defaultAccumulatedInterestToBalance,
    setDefaultAccumulatedInterestToBalance,
  ] = React.useState(false);
  const [amountEditabled, setAmountEditabled] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [isSubmit, setIsSubmit] = React.useState(false);
  const [submitTitle, setSubmitTitle] = React.useState("Confirm");
  const [previewTitle, setPreviewTitle] = React.useState("Preview");
  const refresh = useRefresh();
  const [showFixedPaymentAmount, setShowFixedPaymentAmount] =
    React.useState(false);
  const [showModifiedPaymentTermsAction, setShowModifiedPaymentTermsAction] =
    React.useState(true);
  type FormFields = {
    note_date: string;
    // Add other field names as needed
  };

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm<FormFields>({
    mode: "onBlur",
    defaultValues: {},
  });
  React.useEffect(() => {
    if (record) {
      reset({
        // sAutoRemoval: data.sAutoRemoval || "NO",
      });
    }
  }, [record, reset]);
  let defaultRate = record?.loan?.interestRate;
  if (
    defaultRate == "0.00" ||
    defaultRate == null ||
    defaultRate == undefined
  ) {
    defaultRate = 0;
  }
  const [submitFormData, setSubmitFormData] = React.useState({
    add_accumulated_interest_to_balance: false,
    generate_pdf: false,
    amount: oldAmount.toString(),
    oldAmount: record?.unpaid_principal,
    interest_rate: defaultRate,
    noteDate: dayjs(new Date()).format("YYYY-MM-DD"),
    firstPaymentDate: dayjs(new Date()).format("YYYY-MM-DD"),
    maturityDate: record?.loan?.maturityDate,
    paymentFrequency: record?.loan?.paymentFrequency,
    recalculate_schedule_given_payment_amount: false,
    fixed_payment_amount: "",
    payment_number: record?.loan?.remainingPayments,
    payment_terms: record?.loan?.remainingPayments,
    iPaymentRoundUp: record?.loan?.paymentRoundUp,
    reason: "",
    notes: "",
    late_fee: 0,
    grace_period: 16,
    paymentMethod: "",
    paymentMonth: "",
  });
  const normalizedAmount = normalizeNumericInput(submitFormData.amount);
  const normalizedOldAmount = normalizeNumericInput(oldAmount);

  const setDefaultValue = () => {
    if (
      submitFormData.paymentFrequency == "Monthly" ||
      submitFormData.paymentFrequency == "Single Repayment"
    ) {
      setSubmitFormData({
        ...submitFormData,
        late_fee: max_latefee,
        grace_period: 16,
      });
    } else if (submitFormData.paymentFrequency == "Semimonthly") {
      setSubmitFormData({
        ...submitFormData,
        late_fee: max_latefee / 2,
        grace_period: 8,
      });
    } else if (submitFormData.paymentFrequency == "Weekly") {
      setSubmitFormData({
        ...submitFormData,
        late_fee: max_latefee / 4,
        grace_period: 6,
      });
    } else if (submitFormData.paymentFrequency == "Bi-Weekly") {
      setSubmitFormData({
        ...submitFormData,
        late_fee: max_latefee / 2,
        grace_period: 8,
      });
    }
    if (adjust_latefee == "No" || adjust_latefee == "") {
      setSubmitFormData({
        ...submitFormData,
        late_fee: max_latefee,
      });
    }
    if (adjust_grace_period == "No" || adjust_grace_period == "") {
      setSubmitFormData({
        ...submitFormData,
        grace_period: max_grace_period,
      });
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleRefreshFun = () => {
    refresh();
  };

  const handleClose = () => {
    setOpen(false);
    setIsSubmit(false);
    setPreviewData([]);
    setRevisedData([]);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
    // refresh();
  };
  const handleCloseWhenPreview = () => {
    setOpen(false);
    // setIsSubmit(true);
    setIsSubmit(false);
    setPreviewData([]);
    setRevisedData([]);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
    // refresh();
  };
  const handelGoBackModifyDialog = () => {
    setIsSubmit(false);
    setPreviewData([]);
    setRevisedData([]);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
    setOpen(true);
  };
  const handleDeleteBackToModifyFromPdfDialog = () => {
    setShowGeneratePdfDialog(false);
    setOpen(true);
  };
  const formatRate = (num: string | number | null | undefined) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };
  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i],
      });
    }
  }
  const defautPaymentFreqList: { label: any; value: any }[] = [];
  if (record.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setSubmitFormData({
      ...submitFormData,
      [name]: value,
    });
  };

  const ReasonOptionList = [
    { label: "Select", value: "" },
    { label: "Borrower on Leave", value: "Borrower on Leave" },
    {
      label: "Borrower no Longer Employed",
      value: "Borrower no Longer Employed",
    },
    { label: "New Payment Method", value: "New Payment Method" },
    {
      label: "Add Accumulated Interest to Principal",
      // value: "Add Accumulated Interest To Modified Principal Balance",
      value: "Add Accumulated Interest to Principal",
    },
    { label: "Forgiveness", value: "Forgiveness" },
    { label: "Prepayment", value: "Prepayment" },
  ];

  //when note_date, first_payment_date, payment_frequency, interest_rate, amount change, call this function
  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      getMaturityDate();
      // console.log("useEffect submitFormData ===>", submitFormData);
    }, 3000);

    return () => window.clearTimeout(timer);
  }, [
    submitFormData.noteDate,
    submitFormData.firstPaymentDate,
    submitFormData.paymentFrequency,
    submitFormData.interest_rate,
    // submitFormData.amount,
    submitFormData.payment_number,
    submitFormData.fixed_payment_amount,
  ]);

  const getMaturityDate = async () => {
    //first payment date > today and first payment date > note date
    if (dayjs(submitFormData.firstPaymentDate).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      return false;
    }
    if (
      dayjs(submitFormData.firstPaymentDate).isBefore(
        dayjs(submitFormData.noteDate),
        "day"
      )
    ) {
      errorNotify("First Payment Date must be greater than Note Date");
      return false;
    }
    if (submitFormData?.paymentFrequency == "") {
      errorNotify("Please select Payment Frequency");
      return false;
    }
    const formJson = {
      userset: "yes",
      applicationId: appId,
      payment_frequency: submitFormData.paymentFrequency,
      amount: parseRequiredNumber(submitFormData.amount),
      iterm: Number(record?.terms),
      rate: submitFormData.interest_rate,
      first_payment_date: submitFormData.firstPaymentDate,
      note_date: submitFormData.noteDate,
      payment_number: Number(submitFormData.payment_number),
      payment_terms: Number(submitFormData.payment_terms),
      maturity_date: "",
      fixed_payment_amount: submitFormData.fixed_payment_amount
        ? parseOptionalNumber(submitFormData.fixed_payment_amount)
        : "",
      paymentMethold: "",
      paymentMonth: "",
    };

    // console.log("getMaturityDate formJson 111===>", submitFormData.amount);

    if (
      formJson.amount == null ||
      formJson.amount == 0 ||
      // formJson.rate == "" ||
      formJson.rate == null ||
      formJson.payment_number == null ||
      formJson.payment_number == 0 ||
      formJson.payment_frequency == "" ||
      formJson.payment_frequency == null ||
      formJson.first_payment_date == "" ||
      formJson.first_payment_date == null ||
      formJson.note_date == "" ||
      formJson.note_date == null
    ) {
      // errorNotify("Please fill in all the required fields");
      return false;
    }

    const reqUrl = `calculate/getmaturitydate`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (response && response.status == "200") {
      setSubmitFormData((prev) => ({
        ...prev,
        maturityDate: response.data.maturity_date,
        payment_terms: response.data.terms,
        payment_number: response.data.payment_count,
      }));
      setMinFixedAmount(response.data.fixed_min_amount);
      // setIsSubmit(true);
      setIsSubmit(false);
    } else {
      errorNotify("Error in calculating maturity date");
    }
  };

  const handleSubmitModify = async () => {
    const formJson = {
      userset: "yes",
      skipexpired: "",
      applicationId: appId,
      note_date: submitFormData.noteDate,
      first_payment_date: submitFormData.firstPaymentDate,
      payment_frequency: submitFormData.paymentFrequency,
      rate: submitFormData.interest_rate,
      amount: normalizeNumericInput(submitFormData.amount),
      oldamount: normalizeNumericInput(submitFormData.oldAmount),
      reason: submitFormData.reason,
      notes: submitFormData.notes,
      late_fee: submitFormData.late_fee,
      grace_period: submitFormData.grace_period,
      payment_number: submitFormData.payment_number,
      payment_terms: submitFormData.payment_terms,
      maturity_date: submitFormData.maturityDate,
      iPaymentRoundUp: submitFormData.iPaymentRoundUp,
      fixed_payment_amount: normalizeNumericInput(
        submitFormData.fixed_payment_amount
      ),
      paymentMethod: submitFormData.paymentMethod,
      paymentMonth: submitFormData.paymentMonth,
      // generate_pdf: submitFormData?.generate_pdf ? "YES" : "NO",
      generate_pdf: record?.bank == "springbankny" ? "YES" : "NO",
      //"origination_fee_type":$('#createPaymentScheduleModal').find('#origination_fee_type').val()
    };
    console.log("handleSubmitModify formJson===>", formJson);

    setSubmitTitle("loading");
    const reqUrl = `create/payment/schedule`;
    const responseBack = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (responseBack && responseBack.code == "200") {
      let previewData = responseBack.data;
      setPreviewData([]);
      setRevisedData([]);
      successNotify("Data saved successfully");
      setLoanModificationPdf(responseBack?.pdflink || "");
      setShowGeneratePdfDialog(responseBack?.pdflink ? true : false);
      handleRefreshFun();
      handleClose();
    } else {
      errorNotify(responseBack?.message || "Data not saved!");
    }

    setIsSubmit(false);
    setSubmitTitle("Confirm");
    setPreviewData([]);
    setRevisedData([]);
  };

  if (havePendingTransfers == true) {
    return (
      <Link
        id="link-loan-modify-payment"
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
          color: "grey",
        }}
      >
        Modify Loan Terms
      </Link>
    );
  }

  const RevisedTable = ({ ...props }) => {
    const revisedData = props.revisedData;
    const curPV = props?.curPV;
    // console.log("revisedData in RevisedTable===>", revisedData);
    // console.log("curPV in RevisedTable===>", curPV);
    return (
      <>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(record?.unpaid_principal)}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(revisedData.amount)}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.interestRate}%
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.rate}%
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.paymentFrequency}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.paymentfrequency}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.maturityDate
              ? formatDate(record.loan.maturityDate)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.maturitydate
              ? formatDate(revisedData.maturitydate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.nextPaymentDate
              ? formatDate(record.loan.nextPaymentDate)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentdate
              ? formatDate(revisedData.nextpaymentdate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.nextPaymentAmount
              ? formatCurrency(record.loan.nextPaymentAmount)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentamount
              ? formatCurrency(revisedData.nextpaymentamount)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {curPV?.dModifyNoteDate &&
            curPV?.dModifyNoteDate != "0000-00-00" &&
            curPV?.dModifyNoteDate != "0000-00-00 00:00:00"
              ? `${formatDate(curPV?.dModifyNoteDate)}`
              : curPV?.dNoteDate &&
                curPV?.dNoteDate != "0000-00-00 00:00:00" &&
                curPV?.dNoteDate != "0000-00-00"
              ? `${formatDate(curPV?.dNoteDate)}`
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.startdate ? formatDate(revisedData.startdate) : ""}
          </Grid>
        </Grid>
      </>
    );
  };
  return (
    <React.Fragment>
      <Link
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
        }}
        onClick={handleClickOpen}
      >
        Modify Loan Terms
      </Link>
      <Dialog
        id="dialog-loan-modify-payment"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            formJson.amount = normalizeNumericInput(formJson.amount);
            formJson.fixed_payment_amount = normalizeNumericInput(
              formJson.fixed_payment_amount
            );

            setPreviewTitle("loading");
            const reqUrl = `create/payment/schedule/preview`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (responseBack && responseBack.code == "200") {
              let previewData = responseBack.data;
              let revisedData = responseBack?.revisedData;
              let previewDataArray = [];
              for (let key in previewData) {
                previewDataArray.push(previewData[key]);
              }
              setPreviewData(previewDataArray);
              setRevisedData(revisedData);
              successNotify("Data saved successfully");
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
            setPreviewTitle("Preview");
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle
            title={`${record?.loan?.loanStatus} Loan`}
            subTitle="Modify Loan Terms"
          />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText component="div">
              {/* {record?.bank !== "springbankny" && ( */}
              <>
                <Typography variant="body1">
                  This function can be used to change the Remaining Principal
                  Balance, Remaining Loan Term, Remaining Payment Frequency,
                  Remaining Payment Interest Rate, or reset the Payment Amount
                  for all future payments.
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ my: 2, color: "red" }}
                >
                  Resetting payment schedule of any kind is limited to only once
                  per day. This change is irreversible. Please check all the
                  inputs and carefully preview the results before clicking
                  “Confirm” to commit the changes.
                </Typography>
              </>
              {/* )} */}
              {previewData.length > 0 && (
                <>
                  {record?.bank == "springbankny" ? (
                    <Box>
                      <Typography
                        variant="body2"
                        component="p"
                        sx={{ color: "red", fontWeight: 600, mb: 0.5 }}
                      >
                        This change is irreversible. Please check all the inputs
                        before clicking “Confirm” to proceed.
                      </Typography>
                      <Typography
                        variant="body2"
                        component="p"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Please review the new payment schedule.
                      </Typography>
                      <Box
                        component="ul"
                        sx={{
                          m: 0,
                          pl: 2.5,
                          "& li": {
                            lineHeight: 1.6,
                            mb: 0.5,
                          },
                        }}
                      >
                        <li>
                          Click <b>"Confirm"</b> to generate loan modification
                          agreement with the new payment schedule.
                        </li>
                        <li>
                          Click <b>"Go Back"</b> to return to modifying loan
                          terms.
                        </li>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {previewData.length ? (
                <>
                  {/* 显示RevisedTable */}
                  <RevisedTable
                    revisedData={revisedData}
                    curPV={record?.curPV}
                    record={record}
                  />
                  <CustomPreviewData data={previewData} />
                </>
              ) : (
                <Box sx={{ overflow: "auto" }}>
                  <Box id="modify-loan-schedule-form" sx={{ mt: 5 }}>
                    <Grid sx={{ mb: 2 }} container>
                      {/* Add Accumulated Interest To Modified Principal Balance: checkbox */}
                      <Grid item xs={5}>
                        <HeaderLabelTitle title="Add Accumulated Interest To Modified Principal Balance" />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          id="add_accumulated_interest_to_balance"
                          name="add_accumulated_interest_to_balance"
                          value={defaultAccumulatedInterestToBalance ? 1 : 0}
                          optionlist={[
                            { label: "Yes", value: "1" },
                            { label: "No", value: "0" },
                          ]}
                          variant="outlined"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setDefaultAccumulatedInterestToBalance(
                              e.target.value == "1" ? true : false
                            );
                            if (e.target.value == "1") {
                              //remaining loan amount + accrued interest amount , and set it to amount, not editable
                              let amount =
                                parseFloat(oldAmount) +
                                parseFloat(accruedInterestAmount);
                              setSubmitFormData({
                                ...submitFormData,
                                amount: Number(amount).toFixed(2).toString(),
                                reason:
                                  "Add Accumulated Interest To Modified Principal Balance",
                              });
                              setAmountEditabled(false);
                            } else {
                              setSubmitFormData({
                                ...submitFormData,
                                amount: oldAmount.toString(),
                                reason: "",
                              });
                              setAmountEditabled(true);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    <Grid sx={{ mb: 2 }} container>
                      {/* Modified Remaining Loan Amount: */}
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="Modified Remaining Loan Amount"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomControlMoneyEditTextField
                          name="amount"
                          defaultValue={submitFormData.amount}
                          value={submitFormData.amount}
                          readonly={true}
                          editControl={amountEditabled}
                          min={min_amount}
                          max={max_amount}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setSubmitFormData({
                              ...submitFormData,
                              amount: e.target.value,
                            });
                            // getMaturityDate();
                          }}
                          required={true}
                          prefix={false}
                          helperText="no"
                          className="amountText"
                        />
                        {/* <TextField
                        name="balance"
                        value={balance}
                        onChange={(e) => {
                          setBalance(e.target.value);
                        }}
                      /> */}
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {normalizedAmount !== normalizedOldAmount && (
                      <Grid sx={{ mb: 2 }} container>
                        <Grid item xs={5}>
                          <HeaderLabelTitle title="Reason" required={true} />
                        </Grid>
                        <Grid item xs={5}>
                          <CustomSelect
                            fullWidth={true}
                            id="reason"
                            name="reason"
                            value={submitFormData.reason}
                            optionlist={ReasonOptionList}
                            required={true}
                            variant="outlined"
                            readonly={
                              submitFormData.reason ==
                              "Add Accumulated Interest To Modified Principal Balance"
                                ? true
                                : false
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setSubmitFormData({
                                ...submitFormData,
                                reason: e.target.value.toString(),
                              });
                            }}
                          />
                        </Grid>
                        <Grid item xs={2}></Grid>
                      </Grid>
                    )}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Modified Interest Rate"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomEditControlSelect
                          // fullWidth={true}
                          variant="outlined"
                          id="interest_rate"
                          name="interest_rate"
                          value={submitFormData.interest_rate}
                          optionlist={defautRateOptionList}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (e.target.value != undefined) {
                              // calMatDate();
                              setSubmitFormData({
                                ...submitFormData,
                                interest_rate: e.target.value.toString(),
                              });
                            }
                            handleInputChange(e);
                            // getMaturityDate();
                          }}
                          helperText="no"
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="Modified Terms Starting Date"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <Controller
                          name="note_date"
                          control={control}
                          render={({ field }) => (
                            <CustomDateTextInput
                              {...field}
                              value={
                                submitFormData.noteDate
                                  ? submitFormData.noteDate
                                  : "today"
                              }
                              required={true}
                              onChange={(value: any) => {
                                setSubmitFormData({
                                  ...submitFormData,
                                  noteDate: value,
                                });
                              }}
                              className="dateText"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="First Payment Due under Modified Terms"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomDateTextInput
                          id="first_payment_date"
                          name="first_payment_date"
                          value={
                            submitFormData.firstPaymentDate
                              ? submitFormData.firstPaymentDate
                              : "today"
                          }
                          required={true}
                          onChange={(value: any) => {
                            setSubmitFormData({
                              ...submitFormData,
                              firstPaymentDate: value,
                            });
                            // getMaturityDate();
                          }}
                          className="dateText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Modified Payment Frequency, select */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Payment Frequency"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          id="payment_frequency"
                          name="payment_frequency"
                          value={submitFormData.paymentFrequency}
                          optionlist={defautPaymentFreqList}
                          required={true}
                          variant="outlined"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setSubmitFormData({
                              ...submitFormData,
                              paymentFrequency: e.target.value.toString(),
                            });
                            // getMaturityDate();
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Recalculate Schedule Given Payment Amount: checkbox and textField */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 2 }}>
                        <HeaderLabelTitle title="Recalculate Schedule Given Payment Amount" />
                      </Grid>
                      <Grid
                        item
                        xs={5}
                        sx={{
                          height: "50px",
                        }}
                      >
                        <Checkbox
                          name="recalculate_schedule_given_payment_amount"
                          defaultChecked={
                            submitFormData.recalculate_schedule_given_payment_amount
                          }
                          color="primary"
                          onChange={(e) => {
                            setSubmitFormData({
                              ...submitFormData,
                              recalculate_schedule_given_payment_amount:
                                e.target.checked,
                            });
                            if (e.target.checked) {
                              setShowFixedPaymentAmount(true);
                              setShowModifiedPaymentTermsAction(false);
                            } else {
                              setShowFixedPaymentAmount(false);
                              setShowModifiedPaymentTermsAction(true);
                            }
                          }}
                          sx={{ mt: 1 }}
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                        {showFixedPaymentAmount && (
                          <TextField
                            sx={{ width: "100px", ml: 2 }}
                            variant="outlined"
                            name="fixed_payment_amount"
                            value={submitFormData.fixed_payment_amount}
                            onChange={(e) => {
                              setSubmitFormData({
                                ...submitFormData,
                                fixed_payment_amount: e.target.value,
                              });
                            }}
                            className="amountText"
                          />
                        )}
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Modified Remaining Number Of Payments: textField, readonly  */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="Modified Remaining Number Of Payments"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomControlEditTextField
                          name="payment_number"
                          defaultValue={submitFormData.payment_number}
                          value={submitFormData.payment_number}
                          onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSubmitFormData({
                              ...submitFormData,
                              payment_number: e.target.value,
                              // payment_terms: e.target.value,
                            });
                            // getMaturityDate();
                          }}
                          required={true}
                          helperText="no"
                          className="numericText"
                          showAction={showModifiedPaymentTermsAction}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* payment_terms ,edit textfield */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="Modified Remaining Loan Term (Months)"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          variant="outlined"
                          name="payment_terms"
                          value={submitFormData.payment_terms}
                          // onChange={(e) => {
                          //   setSubmitFormData({
                          //     ...submitFormData,
                          //     payment_terms: e.target.value,
                          //   });
                          // }}
                          required={true}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                          }}
                          InputProps={{ readOnly: true }}
                          className="numericText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Maturity Date: */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle
                          title="Maturity Date under Modified Terms"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          type="text"
                          variant="outlined"
                          id="maturity_date"
                          name="maturity_date"
                          required={true}
                          value={submitFormData.maturityDate}
                          InputProps={{ readOnly: true }}
                          sx={{
                            background: "#e5e5e5",
                            "& input": { pl: "14px", pt: "5px" },
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                          className="dateText"
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* Round Up Payments Except Last: */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5} sx={{ pt: 1 }}>
                        <HeaderLabelTitle
                          title="Round Up Payments Except Last"
                          required={true}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <CustomSelect
                          fullWidth={true}
                          id="iPaymentRoundUp"
                          name="iPaymentRoundUp"
                          optionlist={[
                            { label: "Yes", value: "1" },
                            { label: "No", value: "0" },
                          ]}
                          value={submitFormData.iPaymentRoundUp}
                          required={true}
                          variant="outlined"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setSubmitFormData({
                              ...submitFormData,
                              iPaymentRoundUp: e.target.value.toString(),
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}></Grid>
                    </Grid>
                    {/* notes */}
                    <Grid sx={{ mb: 2 }} container>
                      <Grid item xs={5}>
                        <HeaderLabelTitle title="Add Note (Max 150 Characters)" />
                      </Grid>
                      <Grid item xs={7}>
                        <TextField
                          id="notes"
                          name="notes"
                          placeholder="Notes"
                          value={submitFormData.notes}
                          multiline={true}
                          minRows={3}
                          fullWidth
                          variant="outlined"
                          onKeyDown={(event) => {
                            event.stopPropagation();
                          }}
                          onChange={(e) => {
                            setSubmitFormData((prev) => ({
                              ...prev,
                              notes: e.target.value,
                            }));
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              )}
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          {/* <CustomButtonCancel
            onClick={isSubmit ? handleCloseWhenPreview : handleClose}
            label={"Go Back"}
          /> */}
          <CustomButtonCancel
            onClick={
              previewData?.length > 0 ? handelGoBackModifyDialog : handleClose
            }
            label={previewData.length > 0 ? "Go Back" : "Cancel"}
          />
          {isSubmit ||
            (!previewData.length && (
              <CustomButtonSubmit
                label={previewTitle}
                disabled={previewTitle == "loading" ? true : false}
              />
            ))}
          {previewData.length > 0 && (
            <>
              {/* {record?.bank == "springbankny" && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="generate_pdf"
                        checked={submitFormData.generate_pdf}
                        color="primary"
                        onChange={(e) => {
                          setSubmitFormData({
                            ...submitFormData,
                            generate_pdf: e.target.checked,
                          });
                        }}
                      />
                    }
                    sx={{
                      mr: 0,
                      "& .MuiFormControlLabel-label": {
                        fontSize: "1rem",
                        fontWeight: "700",
                      },
                    }}
                    label="Generate PDF"
                  />
                  <CustomDownloadFile
                    url={`/download/loan_modify_template/${appId}`}
                    fileName="Loan Modification Template.pdf"
                    tooltip="Download Template"
                  />
                </Box>
              )} */}
              <CustomButtonSave
                color="primary"
                onClick={handleSubmitModify}
                label={submitTitle}
                variant="contained"
                disabled={submitTitle == "loading" ? true : false}
              />
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* Generate PDF Dialog */}
      {showGeneratePdfDialog && (
        <GeneratePdfDialog
          open={showGeneratePdfDialog}
          pdflink={loanModificationPdf}
          appId={appId}
          onDeleteBackToModify={handleDeleteBackToModifyFromPdfDialog}
          onClose={() => setShowGeneratePdfDialog(false)}
        />
      )}
    </React.Fragment>
  );
}
